import { Component, ViewChild } from '@angular/core';
import { MerchantTableViewComponent } from '../../../components/merchant/merchant-table-view/merchant-table-view.component';
import { TableView } from '../../../components/ui/filterable-table/tableView';
import { StorageService } from '../../../core/storage/storageService';
import { Merchant } from '../../../models/merchant/merchant';
import { Options } from '../../../components/ui/filterable-table/options';

@Component({
  selector: 'app-business-details',
  templateUrl: './business-details.component.html',
  standalone: false,
})
export class BusinessDetailsComponent {
  @ViewChild('merchantTable') merchantTableControl:
    | MerchantTableViewComponent
    | undefined;


  pageAccessBit: string = 'portal.merchant-r';

  toggleTableOn: boolean = false;

  selectedMerchant: Merchant | undefined;
  allowBusinessSelection: boolean = true;

  merchantTableOptions: Options = new Options({
    selectAction: 'expand',
  });

  merchantTableView: any;

  constructor(private storage: StorageService) {
    this.selectedMerchant = this.storage.getSelectedLocation();

    this.merchantTableView = new TableView(MerchantTableViewComponent);

    if (!this.selectedMerchant) {
      //throw "my-account: no selected merchant";
      return;
    }
  }

  ngOnInit() {}

  setupLocationTableOptions() {
    let accountId = this.storage.getSelectedLocation()?.accountId;
    if (accountId) {
      this.merchantTableOptions.accountId = accountId;
    } else {
      // this is a problem...
    }

    this.merchantTableOptions.selectRoute = 'merchant/account';
    this.merchantTableOptions.debug = 'business-details component';
    this.merchantTableControl?.setOptions(this.merchantTableOptions);
  }

  ngAfterViewInit() {
    this.setupLocationTableOptions();
  }

  handle_selectedMerchant(merchant: Merchant) {}

  handle_recordSetUpdated(event: any) {
    if (event.recordCount < 2) {
      this.allowBusinessSelection = false;
    }
  }
}
